import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import classes from './LessonAssesments.module.css';
import questionLessonBG from '../../../../assests/LessonViewer/QuestionLessonBG.png'
import defaultBGAssessmentCard from '../../../../assests/LessonViewer/defaultBGAssessmentCard.png'
import AssessmentLessonCard from "./AssessmentLessonCard";
import AssessmentFeedback from '../../../../AssessmentFeedback/AssessmentFeedback';
import StatusBar from '../../../../../lms-shared/StatusBar/StatusBar';
import * as submissionStatus from '../../../../models/SubmissionStatus';
import Card from "../../../../UI/Card";

const LessonAssesments = ({ assessmentAggregation, finalAssessment, learningAssessments, scoreOptions, hundleShowLessonQuestion, setPopupAssessmentLesson }) => {

    const texts = useSelector(state => state.translate.texts);
    const uiData = useSelector((state) => state.general.uiData);

    const getStatuses = (type, a) => {
        switch (type) {
            case 'Aggregation':
                return [{
                    status: assessmentAggregation?.submissionsCount === 0 ? submissionStatus.NoQuestionsAnswer : assessmentAggregation?.submissionsCount === assessmentAggregation?.assessmentsCount ? submissionStatus.AllQuestionsAnswered : submissionStatus.SomeQuestionsAnswered,
                    questionNum: assessmentAggregation?.assessmentsCount,
                    questionComplated: assessmentAggregation?.submissionsCount
                }];
            case 'Learning':
                return [{
                    status: a?.submission?.submissionStatus || "NotStarted",
                    submittedDate: a?.submission?.submittedDate
                }, {
                    status: a.activityType
                }];
            case 'Final':
                return [{
                    status: finalAssessment.submission?.submissionStatus,
                    submittedDate: finalAssessment.submission?.submittedDate,
                    assessmentDueDate: finalAssessment.dueDate
                }];
        }
    }

    const getBGImg = (a) => {
        if (a.submission?.project?.thumbnail || a.baseProject?.thumbnail)
            return a.submission?.project?.thumbnail || a.baseProject?.thumbnail;
        const ideId = JSON.parse(a.contentData)?.IdeId;
        if (ideId)
            return uiData.ides[ideId - 1]?.defaultThumbnail;
        return defaultBGAssessmentCard;
    }

    return (
        <div className={classes.LessonAssesments}>
            {(finalAssessment?.submission?.submissionStatus == submissionStatus.completed ||
                finalAssessment?.submission?.submissionStatus == submissionStatus.scored ||
                finalAssessment?.submission?.submissionStatus == submissionStatus.rejected) &&
                <Card dropClass={classes.CardMain}>
                    <AssessmentFeedback
                        SCORE_EXAMPLE={scoreOptions}
                        submissionStatusId={finalAssessment?.submission?.submissionStatus}
                        remarks={finalAssessment?.submission?.remarks}
                        scoreAdditionalData={JSON.parse(finalAssessment?.submission?.scoreAdditionalData)}
                        submittedByUser={finalAssessment?.submission?.submittedByUser} />
                </Card>
            }

            <Card dropClass={classes.CardMain}>
                <div>
                    <div className={classes.Header}>
                        <p className={classes.Title}>{texts.practiceAndAssignments}</p>
                        {finalAssessment && <StatusBar currentStatus={finalAssessment.submission?.submissionStatus} submittedDate={finalAssessment.submission?.submittedDate} assessmentDueDate={finalAssessment.dueDate} />}
                    </div>

                    {finalAssessment?.dueDate &&
                        <div className={classes.SubmissionDateContainer}>
                            <p className={classes.SubmissionDateText}>{texts.submissionDate}</p>
                            <p className={classes.SubmissionDate}>{moment(finalAssessment.dueDate).format('DD.MM.YY')}</p>
                        </div>
                    }

                    {uiData && assessmentAggregation?.assessmentsCount > 0 || learningAssessments?.length ?
                        <>
                            <p className={classes.TitleCard}>{texts.questionsAndExercises}</p>
                            <div className={classes.QuestionsAndExercises}>
                                {assessmentAggregation?.assessmentsCount > 0 ?
                                    <AssessmentLessonCard
                                        backgroundImage={questionLessonBG}
                                        statuses={getStatuses('Aggregation')}
                                        description={texts.allQuestionsFromLesson}
                                        handleClick={() => hundleShowLessonQuestion()} />
                                    : ''}
                                {learningAssessments?.sort((a, b) => a.externalId - b.externalId)?.map(a =>
                                    <AssessmentLessonCard
                                        key={a.id}
                                        backgroundImage={getBGImg(a)}
                                        statuses={getStatuses('Learning', a)}
                                        description={a.name}
                                        handleClick={() => setPopupAssessmentLesson(a)} />
                                )}
                            </div>
                        </> : ''}
                    <p className={classes.TitleCard}>{texts.submissionTasks}</p>
                    {finalAssessment ?
                        <AssessmentLessonCard
                            backgroundImage={getBGImg(finalAssessment)}
                            statuses={getStatuses('Final')}
                            description={finalAssessment.name}
                            handleClick={() => setPopupAssessmentLesson(finalAssessment)} />
                        :
                        <div className={classes.NoAssessment}>{texts.noAssesments}</div>}
                </div>
            </Card>
        </div >
    )
}

export default LessonAssesments;